import React from "react";
import { FiMap, FiRotateCw } from "react-icons/fi";

import Reveal from "../../../components/ui/Reveal";

import { cn } from "../utils/projetsUtils";

export default function ProjetsSummary({
  loading,
  projets = [],
  selectedId,
  onSelect,
  onRefresh,
}) {
  return (
    <Reveal>
      <section className="rounded-[2rem] border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-800 dark:bg-slate-950 sm:p-6">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div>
            <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-[#1277B9]">
              <FiMap className="h-4 w-4" />
              Sommaire
            </p>

            <h2 className="mt-2 text-xl font-bold text-slate-950 dark:text-white">
              Grands projets publiés
            </h2>

            <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
              Sélectionnez un projet pour afficher son détail.
            </p>
          </div>

          <button
            type="button"
            onClick={onRefresh}
            disabled={loading}
            className="inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 text-sm font-bold text-slate-700 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100 dark:hover:bg-slate-800"
          >
            <FiRotateCw className={cn("h-4 w-4", loading && "animate-spin")} />
            Actualiser
          </button>
        </div>

        {loading && (
          <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {Array.from({ length: 6 }).map((_, index) => (
              <div
                key={index}
                className="h-24 animate-pulse rounded-3xl bg-slate-100 dark:bg-slate-900"
              />
            ))}
          </div>
        )}

        {!loading && projets.length > 0 && (
          <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {projets.map((projet, index) => {
              const active = projet.id === selectedId;

              return (
                <button
                  key={projet.id}
                  type="button"
                  onClick={() => onSelect(projet.id)}
                  className={cn(
                    "group text-left rounded-3xl border p-4 transition",
                    active
                      ? "border-[#1277B9] bg-[#1277B9]/5 shadow-sm"
                      : "border-slate-200 bg-white hover:border-[#1277B9]/50 hover:bg-sky-50 dark:border-slate-800 dark:bg-slate-950 dark:hover:bg-slate-900"
                  )}
                >
                  <div className="flex items-start gap-3">
                    <span
                      className={cn(
                        "inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-2xl text-sm font-bold",
                        active
                          ? "bg-[#1277B9] text-white"
                          : "bg-slate-100 text-slate-500 dark:bg-slate-900 dark:text-slate-300"
                      )}
                    >
                      {index + 1}
                    </span>

                    <div className="min-w-0">
                      <p
                        className={cn(
                          "line-clamp-2 text-sm font-bold leading-snug",
                          active
                            ? "text-[#1277B9]"
                            : "text-slate-800 dark:text-slate-100"
                        )}
                      >
                        {projet.title}
                      </p>

                      {projet.dateLabel && (
                        <p className="mt-2 text-xs font-semibold text-slate-400">
                          Mis à jour le {projet.dateLabel}
                        </p>
                      )}
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        )}
      </section>
    </Reveal>
  );
}